/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

 import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
 import { xCommonUpdate } from "@pacific/App/Handlers/XNG/Common";
 import  { askQuestion, AskQuestionApiParameter } from "@pacific/App/Services/AskQuestionService";
 
 interface Props {
     apiParameter: AskQuestionApiParameter;
     apiResult: { successful: boolean; error?: any };
 }
 
 type Parameter = AskQuestionApiParameter & {
     onSuccess?: () => void;
     onError?: (e: any) => void;
 };
 
 type HandlerType = Handler<Parameter, Props>;
 
 export const BeginLoadingRequest: HandlerType = props => {
     props.dispatch(xCommonUpdate({ key: 'submitQuestionIsLoading', value: true }));
 };
 
 export const DispatchBeginAction: HandlerType = props => { 
     props.apiParameter = {
         ...props.parameter,
     };
 };
 
 export const CallApiWithParameters: HandlerType = async props => { 
     props.apiResult = await askQuestion(props.apiParameter);
 };
 
 export const CallOnError: HandlerType = props => {
     props.dispatch(xCommonUpdate({ key: 'submitQuestionIsLoading', value: false }));
     if (!props.apiResult.successful) {
         props.parameter.onError?.(props.apiResult.error);
     }
 };
 
 export const CallOnSuccess: HandlerType = props => {
     props.dispatch(xCommonUpdate({ key: 'submitQuestionIsLoading', value: false }));
     if (props.apiResult.successful && props.parameter.onSuccess) {
         props.parameter.onSuccess();
     }
 };
 
 export const chain = [BeginLoadingRequest, DispatchBeginAction, CallApiWithParameters, CallOnError, CallOnSuccess];
 
 const askQuestionHandler = createHandlerChainRunner(chain, "AskQuestionHandler");
 export default askQuestionHandler;